import window from 'window-or-global';

export const CloseEvent = (id_list, close_event_ok, close_event_not_ok) => {
  let ok = true;
  if (window.innerWidth <= 768) {
    if (id_list.length > 1) {
      if (
        document.getElementById(id_list[0] + '_m').files[0] &&
        !document.getElementById(id_list[1] + '_m').files[0]
      ) {
        document.getElementById('upload_front').style.display = 'none';
        document.getElementById('upload_back').style.display = 'block';
        return true;
      }
    }
    try {
      document.getElementById('upload_back').style.display = 'none';
    } catch {
      document.getElementById('upload_front').style.display = 'none';
    }
    let a = document.getElementById('doc_container');
    a.style.backgroundColor = 'black';
    a.style.height = '0';
    a.style.position = 'absolute';
    a.style.opacity = '0';
    document.getElementById('mobile_doc_list').style.display = 'none';
    document.getElementById('doc_list_container').style.display = 'block';
    document.getElementById('upload_container').style.display = 'none';
    let reader = new FileReader();
    let img = document.getElementById('card_photo');
    let doc = document.getElementById(id_list[0] + '_m');
    if (doc.files[0].type === 'application/pdf') {
      img.style.display = 'none';
      img = document.getElementById('card_photo_iframe');
      img.style.display = 'block';
    }
    try {
      reader.onloadend = function() {
        img.src = reader.result;
      };
      reader.readAsDataURL(doc.files[0]);
    } catch (e) {}

    if (id_list.length > 1) {
      let reader1 = new FileReader();

      let img1 = document.getElementById('card_photo_back');
      let doc1 = document.getElementById(id_list[1] + '_m');
      if (doc1.files[0].type === 'application/pdf') {
        img1.style.display = 'none';
        img1 = document.getElementById('card_photo_iframe');
        img1.style.display = 'block';
      }
      try {
        reader1.onloadend = function() {
          img1.src = reader1.result;
        };
        reader1.readAsDataURL(doc1.files[0]);
      } catch (e) {}
    }
    document.getElementById('mobile_custom_list').style.display = 'none';
    // document.getElementById(id_list[0] +"re_upload").style.display = 'block'
  } else if (id_list.length > 0 && window.innerWidth > 768) {
    for (let i = 0; i < id_list.length; i++) {
      ok = ok && document.getElementById(id_list[i]).files[0];
      if (!ok) {
        return false;
      }
    }

    for (let j = 0; j < id_list.length; j++) {
      let hider = document.getElementById(id_list[j] + '_container');

      document.getElementById(id_list[j] + '_area').style.display = 'block';

      hider.children[0].style.display = 'none';
      hider.children[1].style.display = 'block';

      let documnet_area = document.getElementById(id_list[j] + '_area');

      documnet_area.style.visibility = 'visible';
      documnet_area.children[0].style.width = '90%';
      documnet_area.children[0].style.margin = 'auto';
      documnet_area.children[0].style.height = '118px';

      documnet_area.style.height = '150px';
      documnet_area.style.overflow = 'scroll';
      document.getElementById(id_list[j] + 're_upload').style.display = 'block';
    }

    // Left Side Block
    let upload_container = document.getElementById('upload_container');

    upload_container.style.display = 'block';
    upload_container.style.width = '50%';
    upload_container.children[0].style.width = '100%';

    if (id_list.length > 1) {
      upload_container.children[1].style.width = '100%';
    }

    // Right SIde Block
    let doc_values = document.getElementById('doc_values_division');
    doc_values.style.display = 'block';

    // Swipe The Block
    let doc_container = document.getElementById('doc_value_container');
    doc_container.style.flexDirection = 'row-reverse';
  }

  close_event_ok();

  return true;
};
